export default __webpack_public_path__ + "static/media/product5.570a0273.jpg";